import { useState, useEffect } from 'react';

export const useLocalStorage = <T>(
  key: string,
  initialValue: T
): [T, (value: T) => void] => {
  const [storedValue, setStoredValue] = useState<T>(initialValue);

  useEffect(() => {
    const localStorageValueString = localStorage.getItem(key);
    if (localStorageValueString) {
      const localStorageValue = JSON.parse(localStorageValueString) as T;
      setStoredValue(localStorageValue);
    }
  }, []);

  const setValue = (newValue: T) => {
    localStorage.setItem(key, JSON.stringify(newValue));
    setStoredValue(newValue);
  };

  return [storedValue, setValue];
};
